
import {Component, Prop, Vue} from 'vue-property-decorator';
import {getRandomTip} from "../../../play-class/utils/TipsUtils";

@Component
export default class PlayerLoader extends Vue {
  @Prop({default: true}) displayTips: boolean;
  @Prop({default: true}) isFullscreen: boolean;

  private getRandomTip() {
    return getRandomTip();
  }
}
